/* V9 visitor toy: native cursors and hold-to-draw bow. A frame loop runs only during a draw. */
(() => {
  'use strict';
  if (document.querySelector('.avalon-armory')) return;
  const root = document.documentElement;
  const mouse = matchMedia('(hover: hover) and (pointer: fine)');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'avalon-armory';
  const choices = ['normal', 'knight', 'bow'];
  let mode = mouse.matches ? 'knight' : 'normal';
  try { const saved = localStorage.getItem(key); if (choices.includes(saved)) mode = saved; } catch (_) { /* Session choice still works. */ }
  if (!mouse.matches && mode === 'knight') mode = 'normal';
  let controls, panel, hint;
  const arrows = new Map();
  const interactive = 'a,button,input,select,textarea,label,summary,details,form,video,audio,iframe,[contenteditable]:not([contenteditable="false"]),[role="button"],[role="link"],[role="dialog"],.avalon-armory,.avalon-instagram-feed';
  const knight = '<path d="M2 2 8 4 22 20 19 23 5 8Z" fill="SILVER"/><path d="m3 3 17 18"/><path d="m14 23 9-9 2 2-9 9Z" fill="GOLD"/><path d="m22 23 5 5-2 2-5-5Z" fill="GOLD"/><path d="M16 7Q23 1 29 7V15L23 19 17 15Z" fill="PAPER"/><path d="M17 9h12m-6-5v14m-4-6v3m8-3v3"/>';
  function cursors() {
    const tokens = getComputedStyle(root);
    const colors = {INK:tokens.getPropertyValue('--rustic-ink').trim(), GOLD:tokens.getPropertyValue('--gold').trim(), SILVER:tokens.getPropertyValue('--night-silver').trim(), PAPER:tokens.getPropertyValue('--rustic-sheet').trim()};
    const svg = shape => '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="INK" stroke-width="1.2" stroke-linejoin="round" stroke-linecap="round">' + shape + '</g></svg>';
    for (const [name, shape, hotspot] of [['knight',knight,'2 2']]) {
      const art = svg(shape).replace(/INK|GOLD|SILVER|PAPER/g, token => colors[token]);
      root.style.setProperty('--avalon-cursor-' + name, 'url("data:image/svg+xml,' + encodeURIComponent(art) + '") ' + hotspot);
    }
  }
  function removeArrow(arrow) { clearTimeout(arrows.get(arrow)); arrows.delete(arrow); arrow.remove(); }
  function clearArrows() { cancelDraw(); for (const arrow of arrows.keys()) removeArrow(arrow); field?.remove(); field=null; }
  function render() {
    if (!mouse.matches && mode === 'knight') mode = 'normal';
    root.dataset.avalonArmory = mode;
    if (!controls) return;
    controls.querySelector('[value="knight"]').disabled = !mouse.matches;
    controls.querySelectorAll('input').forEach(input => { input.checked = input.value === mode; });
    controls.querySelector('.avalon-armory__label').textContent = mode === 'bow' ? 'Bow ready' : 'Armory';
    hint.textContent = mode === 'bow'
      ? motion.matches ? 'Arrow effects are off for reduced motion.' : mouse.matches ? 'Hold the background to draw. Release to fire. Hold longer for a faster shot; move to aim.' : 'Hold the background to draw; release to fire. Longer holds shoot faster. Swiping scrolls instead.'
      : mouse.matches ? 'Choose your cursor. Bow mode lets you loose arrows into the page.' : 'Choose Bow, then hold the background and release to shoot. Swipe to scroll as usual.';
    controls.querySelector('[data-avalon-draw]').hidden = mode !== 'bow';
    controls.querySelector('[data-avalon-draw]').disabled = motion.matches;
    if (motion.matches) clearArrows();
    else if (!draw) restBow();
  }
  function choose(value) {
    mode = choices.includes(value) ? value : 'normal';
    try { localStorage.setItem(key,mode); } catch (_) { /* Storage is optional. */ }
    clearArrows(); render();
  }
  function init() {
    if (controls) { clearArrows(); render(); return; }
    controls = document.createElement('div'); controls.className = 'avalon-armory';
    // Static local markup: no fetched HTML or customer data.
    controls.innerHTML = '<details><summary><span aria-hidden="true">⚔</span> <span class="avalon-armory__label">Armory</span></summary><div class="avalon-armory__panel"><fieldset><legend>Choose your equipment</legend><label class="avalon-armory__knight"><input type="radio" name="avalon-equipment" value="knight" aria-label="Knight’s sword cursor"> Knight’s sword</label><label><input type="radio" name="avalon-equipment" value="bow" aria-label="Bow and arrow"> Bow &amp; arrow</label><label><input type="radio" name="avalon-equipment" value="normal" aria-label="Normal pointer"> Normal</label></fieldset><p class="avalon-armory__hint" aria-live="polite"></p><button type="button" aria-label="Clear arrows">Clear arrows</button><button type="button" data-avalon-draw aria-label="Hold Space or Enter to draw, release to fire a practice shot">Practice shot · hold</button><p class="avalon-armory__escape">Esc puts your equipment away.</p></div></details>';
    document.body.append(controls);
    panel = controls.querySelector('details'); hint = controls.querySelector('.avalon-armory__hint');
    controls.addEventListener('change',event => { if (event.target.matches('input[type="radio"]')) choose(event.target.value); });
    controls.querySelector('button').addEventListener('click',clearArrows);
    cursors(); render();
  }
  let draw = null, rig = null, field = null, frame = 0, recoilTimer = 0;
  const chargeTime = 1400;
  const arrowArt = '<svg viewBox="0 0 76 20" width="76" height="20" fill="none" aria-hidden="true"><path class="avalon-arrow__shadow" d="M5 11h64"/><path class="avalon-arrow__shaft" d="M5 9h62"/><path class="avalon-arrow__head" d="m64 4 11 5-11 5 2-5Z"/><path class="avalon-arrow__feather" d="m4 9-4-7h11l6 7-6 7H0Z"/><path class="avalon-arrow__shaft" d="M2 9h19"/></svg>';
  function cancelDraw() {
    cancelAnimationFrame(frame); frame = 0; draw = null;
    clearTimeout(recoilTimer);
    delete root.dataset.avalonDrawing;
    restBow();
  }
  function bowAnchor() {
    return {x:innerWidth-Math.min(100,innerWidth*.23),y:Math.max(90,Math.min(innerHeight*.5,innerHeight-310))};
  }
  function restBow() {
    if (mode !== 'bow') { rig?.remove(); rig=null; return; }
    if (!rig) {
    rig = document.createElement('div');rig.className='avalon-bow';rig.setAttribute('aria-hidden','true');
    
    rig.innerHTML='<div class="avalon-bow__weapon"><svg viewBox="0 0 144 140" width="144" height="140"><path class="avalon-bow__limb" d="M64 12Q116 70 64 128"/><path class="avalon-bow__string" d="M64 12L64 70L64 128"/><path class="avalon-bow__grip" d="M89 58V82"/><g class="avalon-bow__nocked"><path class="avalon-arrow__shaft" d="M64 70h66"/><path class="avalon-arrow__head" d="m128 65 11 5-11 5 2-5Z"/><path class="avalon-arrow__feather" d="m67 70-6-6h12l6 6-6 6H61Z"/></g></svg></div><span class="avalon-bow__aim"></span><div class="avalon-bow__power"><span class="avalon-bow__power-label"></span><span class="avalon-bow__power-track"><i class="avalon-bow__power-fill"></i></span></div>';
    document.body.append(rig);
    rig.querySelector('.avalon-bow__weapon').style.transform='rotate(-155deg)';
    }
    const anchor=bowAnchor();
    rig.style.setProperty('--bow-x',anchor.x+'px');rig.style.setProperty('--bow-y',anchor.y+'px');
    rig.classList.remove('avalon-bow--released');rig.classList.add('avalon-bow--idle');
    rig.querySelector('.avalon-bow__string').setAttribute('d','M64 12L64 70L64 128');
    rig.querySelector('.avalon-bow__limb').setAttribute('d','M64 12Q116 70 64 128');
    rig.querySelector('.avalon-bow__nocked').setAttribute('visibility','visible');
    rig.querySelector('.avalon-bow__nocked').setAttribute('transform','translate(0 0)');
  }
  function targetPoint(x,y) {
    return {x:Math.max(16,Math.min(x,innerWidth-16)),y:Math.max(24,Math.min(y,innerHeight-36))};
  }
  function paintDraw() {
    if (!draw || !rig) return;
    const power = Math.min(1,Math.max(0,(performance.now()-draw.started)/chargeTime));
    const pull = 64 - 40*power;
    const angle = Math.atan2(draw.y-draw.originY,draw.x-draw.originX)*180/Math.PI;
    rig.querySelector('.avalon-bow__weapon').style.transform = 'rotate('+angle+'deg)';
    rig.querySelector('.avalon-bow__string').setAttribute('d',`M64 12 L${pull} 70 L64 128`);
    rig.querySelector('.avalon-bow__limb').setAttribute('d',`M64 12 Q${116-12*power} 70 64 128`);
    rig.querySelector('.avalon-bow__nocked').setAttribute('transform',`translate(${-40*power} 0)`);
    rig.querySelector('.avalon-bow__power-fill').style.transform = 'scaleX('+power+')';
    rig.querySelector('.avalon-bow__power-label').textContent = power === 1 ? 'Fully drawn' : 'Drawing… '+Math.round(power*100)+'%';
    rig.style.setProperty('--aim-x',draw.x+'px');rig.style.setProperty('--aim-y',draw.y+'px');
  }
  function tickDraw() { if (!draw) return; paintDraw(); frame=requestAnimationFrame(tickDraw); }
  function beginDraw(x,y,id,practice=false) {
    cancelDraw();
    const point = targetPoint(x,y);
    draw = {...point, id, practice, started:performance.now(),originX:bowAnchor().x,originY:bowAnchor().y};
    rig.classList.remove('avalon-bow--idle','avalon-bow--released');
    root.dataset.avalonDrawing='true';
    if (!practice) panel.open=false;
    tickDraw();
  }
  function releaseDraw() {
    if (!draw) return;
    const shot = draw, power=Math.min(1,(performance.now()-draw.started)/chargeTime);
    cancelAnimationFrame(frame);frame=0;draw=null;delete root.dataset.avalonDrawing;
    // A relaxed shot travels at 420px/s; a full draw at 2020px/s.
    const radians=Math.atan2(shot.y-shot.originY,shot.x-shot.originX);
    const launchX=shot.originX+Math.cos(radians)*(67-40*power),launchY=shot.originY+Math.sin(radians)*(67-40*power);
    const dx=shot.x-launchX,dy=shot.y-launchY,distance=Math.hypot(dx,dy);
    const angle=radians*180/Math.PI;
    const duration=Math.max(100,Math.min(1600,distance/(420+1600*power)*1000));
    rig.querySelector('.avalon-bow__nocked').setAttribute('visibility','hidden');
    rig.classList.add('avalon-bow--released');
    rig.querySelector('.avalon-bow__string').setAttribute('d','M64 12L72 70L64 128');
    rig.querySelector('.avalon-bow__limb').setAttribute('d','M64 12Q116 70 64 128');
    recoilTimer=setTimeout(restBow,260);
    if (!field) {field=document.createElement('div');field.className='avalon-arrow-field';field.setAttribute('aria-hidden','true');document.body.append(field);}
    const arrow=document.createElement('span');arrow.className='avalon-arrow';arrow.setAttribute('aria-hidden','true');
    arrow.style.left=shot.x+'px';arrow.style.top=shot.y+'px';
    arrow.style.setProperty('--flight-x',(-dx)+'px');arrow.style.setProperty('--flight-y',(-dy)+'px');
    arrow.style.setProperty('--shot-angle',angle+'deg');arrow.style.setProperty('--flight-duration',duration+'ms');
    arrow.style.setProperty('--fade-delay',(duration+5200)+'ms');arrow.innerHTML=arrowArt;
    field.append(arrow);arrows.set(arrow,setTimeout(()=>removeArrow(arrow),duration+5800));
    if(arrows.size>8) removeArrow(arrows.keys().next().value);
  }
  function validBackground(event) {
    return event.target instanceof Element && !event.target.closest(interactive) && !document.getSelection()?.toString();
  }
  document.addEventListener('pointerdown',event=>{
    if (draw && event.pointerId!==draw.id) {cancelDraw();return;}
    if(!controls || mode!=='bow' || motion.matches || event.defaultPrevented || event.button!==0 || event.isPrimary===false || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    const practice=event.target instanceof Element && event.target.closest('[data-avalon-draw]');
    if (!practice && !validBackground(event)) return;
    beginDraw(practice ? innerWidth*.65 : event.clientX,practice ? innerHeight*.4 : event.clientY,event.pointerId,Boolean(practice));
  });
  document.addEventListener('pointermove',event=>{
    if (!draw || event.pointerId!==draw.id || draw.practice) return;
    Object.assign(draw,targetPoint(event.clientX,event.clientY));
  });
  document.addEventListener('pointerup',event=>{
    if(!draw || event.pointerId!==draw.id) return;
    if(!draw.practice && !validBackground(event)) {cancelDraw();return;}
    if(!draw.practice) Object.assign(draw,targetPoint(event.clientX,event.clientY));
    releaseDraw();
  });
  document.addEventListener('pointercancel',cancelDraw);
  document.addEventListener('contextmenu',event=>{if(draw && validBackground(event)) event.preventDefault();});
  document.addEventListener('click',event=>{
    if(!controls) return;
    if(!controls.contains(event.target)) panel.open=false;
    // Assistive-technology activation of the practice button gets an uncharged shot.
    if(event.detail===0 && event.target.closest?.('[data-avalon-draw]') && mode==='bow' && !motion.matches) {
      beginDraw(innerWidth*.65,innerHeight*.4,'keyboard',true);releaseDraw();
    }
  });
  document.addEventListener('keydown',event=>{
    if(![' ','Enter'].includes(event.key) || !event.target.closest?.('[data-avalon-draw]') || mode!=='bow' || motion.matches) return;
    event.preventDefault();
    if(!event.repeat && !draw) beginDraw(innerWidth*.65,innerHeight*.4,'keyboard',true);
  });
  document.addEventListener('keyup',event=>{
    if(draw?.id==='keyboard' && [' ','Enter'].includes(event.key)) {event.preventDefault();releaseDraw();}
  });
  window.addEventListener('blur',clearArrows);
  window.addEventListener('scroll',clearArrows,{passive:true});
  window.addEventListener('resize',clearArrows);
  document.addEventListener('keydown',event => {
    if (event.key !== 'Escape' || !controls) return;
    const wasOpen = panel.open;
    panel.open = false; choose('normal');
    if (wasOpen) controls.querySelector('summary').focus();
  });
  document.addEventListener('avalon:navigated',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('visibilitychange',() => { if (document.hidden) clearArrows(); });
  for (const query of [mouse,motion]) query.addEventListener('change',render);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
